"use client";
import React, { useState } from "react";
export const OriginModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const handleOriginModalTriggerClick = (event) => {
    setPosition({
      x: event.clientX,
      y: event.clientY,
    });
    setIsOpen(true);
    setIsClosing(false);
  };
  const handleOriginModalClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsOpen(false);
    }, 300); // Match the animation duration
  };

  return {
    isOpen,
    isClosing,
    position,
    handleOriginModalTriggerClick,
    handleOriginModalClose,
    setIsOpen,
  };

  // return (
  //     <div className="min-h-screen bg-gray-100 p-4">
  //         <Trigger buttonRef={buttonRef} handleClick={handleClick}>
  //             <h2 className="text-2xl font-bold mb-4">Click to Open Modal</h2>
  //             <p className="text-gray-600">
  //                 This box starts 12rem (192px) from the top of its container. Click to
  //                 see the modal animation.
  //             </p>
  //         </Trigger>


  //     </div>
  // );
};

export function Trigger({ children, buttonRef, handleClick }) {
  return (
    <div className="mt-48  max-w-md ms-[100px]">
      <button
        ref={buttonRef}
        onClick={handleClick}
        className="w-full bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow"
      >
        {children}
      </button>
    </div>
  );
}

export function Modal({
  children,
  handleClose,
  isClosing,
  position,
  isOpen,
  isPiP,
}) {
  if (!isOpen) return null;

  return (
    <div
      className={`fixed w-screen h-screen inset-0 flex items-center justify-center ${
        isPiP ? "bg-opacity-0 pointer-events-none -z-40" : "bg-opacity-30 z-40 "
      } transition-opacity duration-75 ${
        isClosing ? "opacity-0" : "opacity-100"
      }`}
      style={{ width: isPiP ? "100%" : "100%" }}
      onClick={() => handleClose?.()} // Handle close on overlay click
    >
      <div
        onClick={(e) => e.stopPropagation()} // Prevent close on modal content click
        className="bg-transparent z-50 w-screen h-screen"
        style={{
          animation: isClosing
            ? "fade-out 0.2s ease-in forwards"
            : "fade-in 0.2s ease-out forwards",
        }}
      >
        {children}
      </div>
      <style jsx global>{`
        @keyframes modal-open {
          0% {
            opacity: 0;
            transform: scale(0);
          }
          100% {
            opacity: 1;
            transform: scale(1);
          }
        }

        @keyframes modal-close {
          0% {
            opacity: 1;
            transform: scale(1);
          }
          100% {
            opacity: 0;
            transform: scale(0.9);
          }
        }

        @keyframes fade-up-in {
          0% {
            opacity: 0;
            transform: translateY(20px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fade-down-out {
          0% {
            opacity: 1;
            transform: translateY(0);
          }
          100% {
            opacity: 0;
            transform: translateY(20px);
          }
        }

        @keyframes fade-in {
          0% {
            opacity: 0;
          }
          100% {
            opacity: 1;
          }
        }

        @keyframes fade-out {
          0% {
            opacity: 1;
          }
          100% {
            opacity: 0;
          }
        }
      `}</style>
    </div>
  );
}
